import {setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {UIProfileLinkController} from '../../../shared/scripts/profile/UIProfileLinkController'
import {UIProfileSettingsController} from '../../../shared/scripts/profile/UIProfileSettingsController'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils'
import {ViewPopupEditProfile} from '../../../shared/scripts/ui_popup/ViewPopupEditProfile'
import {UIWProfileUsernameController} from '../ui_html/header/UIWProfileUsernameController'
import {PlayerColor} from '@colonist/game-states'
import {ProfileEditAjaxEndPoints} from '../../../shared/scripts/profile/ProfileEditAjaxEndPoints'
import {UIWDeviceInfoPopup} from '../ui_popup/UIWDeviceInfoPopup'

export class UIWProfileSettingsController extends UIProfileSettingsController {
    private readonly username: string
    private readonly profileLinkController: UIProfileLinkController
    private readonly editProfileButton: HTMLDivElement
    private readonly deviceInfoButton: HTMLDivElement

    private profileIsCurrentUser: boolean

    constructor(username: string, profileLinkController: UIProfileLinkController) {
        super()
        this.username = username
        this.profileLinkController = profileLinkController
        this.editProfileButton = document.getElementById('page-profile-edit-profile') as HTMLDivElement
        this.deviceInfoButton = document.getElementById('page-profile-device-info') as HTMLDivElement
        this.init()
    }

    private init() {
        this.profileIsCurrentUser = this.isProfileCurrentUser()

        if(!this.profileIsCurrentUser) {
            this.hideSettingsTab()
            this.redirectToMainProfileSection()
            return
        }

        this.initEditProfileButton()
        this.initDeviceInfoButton()
    }

    private isProfileCurrentUser(): boolean {
        if(ClientUserState.userState == undefined) return false
        return ClientUserState.userState.username.toLowerCase() == decodeURIComponent(this.username.toLowerCase())
    }

    hideSettingsTab() {
        if(this.profileLinkController.settingsSectionLink == undefined) return
        this.profileLinkController.settingsSectionLink.style.display = 'none'
    }

    showSettingsTab() {
        if(this.profileLinkController.settingsSectionLink == undefined) return
        this.profileLinkController.settingsSectionLink.style.display = 'flex'
    }

    private redirectToMainProfileSection() {
        if(this.profileLinkController.activeLink != this.profileLinkController.settingsSectionLink) return
        navigateToPage(`/profile/${this.username}`)
    }

    private initEditProfileButton() {
        setElementOnClick(this.editProfileButton, () => {
            new ViewPopupEditProfile({
                usernameController: UIWProfileUsernameController,
                selectColorAction: async(color: PlayerColor) => await ProfileEditAjaxEndPoints.updatePreferredColor(color),
            })
        })
    }

    private initDeviceInfoButton() {
        setElementOnClick(this.deviceInfoButton, () => new UIWDeviceInfoPopup().show())
    }
}
